import script from "./AttendeePicker.vue?vue&type=script&setup=true&lang=js"
export * from "./AttendeePicker.vue?vue&type=script&setup=true&lang=js"

import "./AttendeePicker.vue?vue&type=style&index=0&id=311c21e3&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-311c21e3"]])

export default __exports__